<div class="text-center" *ngIf="visible">
    <div class="spinner-border text-primary" role="status">
    </div>
    <p></p>
    <span>&nbsp;&nbsp;&nbsp;&nbsp;Aguarde...</span>
</div>